import { Card, NothingHere } from "components/elements";
import { useBenchmark } from "hooks/useBenchmark";
import { BenchmarkListTable } from "screens/benchmark/BenchmarkTable";

export const BenchMark = () => {
    const { data, isInitialLoading, error, nothingFound } = useBenchmark({ type: "benchmark" });

    return (
        <Card>
            <div className="flex flex-col gap-4">
                {nothingFound ? <NothingHere /> : null}

                {isInitialLoading && <div>Loading...</div>}
                {error && <div>Error: {error.message}</div>}
                {data && data?.reports?.length > 0 ? (
                    <>
                        <div className="font-sans text-[28px] font-semibold text-[#424242]">
                            Benchmark
                        </div>
                        <BenchmarkListTable benchmark={data.reports} />
                    </>
                ) : null}
            </div>
        </Card>
    );
};
